var club_input = '#id_club';
var club_input_wrapper = '#id_club_wrapper';
var club_tag = '#id_club_tag';
var upcoming_competitions = '#upcoming-competitions';
var bracket_opened = false;


function bracket_close(close = true) {
  if (bracket_opened = false) {
    return;
  }
  bracket_opened = false;
  history.replaceState(null, null, competition_url);
  if (close) {
    modal_close('bracket-modal');
  }
}

$(window).on('popstate', function () {
  bracket_close();
});

$(document).on('click', '#bracket-modal .modal-close', function () {
  bracket_close(false);
});

function reload_upcoming_competitions(club_id) {
  if ($(upcoming_competitions).length == 0) {
    club_save(club_id, true);
    return;
  }

  //$(upcoming_competitions).html(animated_background);
  $.ajax({
    method: 'POST',
    url: competitions_api,
    dataType: 'json',
    data: {
      type: 'upcoming_competitions',
      club: club_id,
    }
  }).done(function (ret) {
    $(upcoming_competitions).html(ret.html);
  }).fail(function (ret) {
    show_error(error_message);
  });
}

function club_save(club_id, reload) {
  if (!club_id) {
    if (reload) {
      location.reload();
    }
    return;
  }
  $.ajax({
    method: 'POST',
    url: competitions_api,
    dataType: 'json',
    data: {
      type: 'club_save',
      club: club_id,
    }
  }).done(function (ret) {
    if (reload) {
      location.reload();
    }
  }).fail(function (ret) {
    show_error(error_message);
  });
}

function competitions_api_request(data, elem = null) {
  if (data.type == 'competition_refresh') {
    add_loading(elem);
  }
  var form_data = new FormData();
  for (let key in data) {
    form_data.append(key, data[key]);
  }

  if (data.type == 'bracket') {
    $('#bracket-modal .cat-title').html('');
    $('#bracket-container').html(loading_text);
  }

  $.ajax({
    method: 'POST',
    url: competitions_api,
    dataType: 'json',
    data: form_data,
    headers: {
      'X-CSRFToken': $.cookie('csrftoken'),
    },
    processData: false,
    contentType: false,
  }).done(function (ret) {
    if (data.type == 'bracket') {
      bracket_opened = true;
      $('#bracket-modal .cat-title').html(ret.title);
      $('#bracket-container').html(ret.bracket);
      window.history.pushState(null, null, ret.url);
    } else if (data.type == 'club_forget') {
      $(club_tag).hide();
      $(club_tag + ' span').html('');
      $(club_input_wrapper).show();
      $(club_input).focus();
      reload_upcoming_competitions(null);
    } else if (data.type == 'competition_refresh') {
      if (ret.Level == 'success') {
        show_success(ret.Message);
      } else {
        show_error(ret.Message);
      }
      async_done(ret, elem);
    } else {
      async_done(ret, elem);
    }
  }).fail(function () {
    show_error(error_message);
  });
}

function dark_mode_toggle() {
  $(document).on('click', '#dark-mode-toggle', function () {
    var dark_mode = $('body').hasClass('dark-mode');
    if (dark_mode) {
      $('body').removeClass('dark-mode');
      $('#light-mode').hide();
      $('#dark-mode').show();
      document.querySelector('meta[name="theme-color"]').setAttribute('content', '#FAFAFA');
      $.cookie('dark_mode', 'false', { expires: 365, path: '/' });
    } else {
      $('body').addClass('dark-mode');
      $('#dark-mode').hide();
      $('#light-mode').show();
      document.querySelector('meta[name="theme-color"]').setAttribute('content', '#262626');
      $.cookie('dark_mode', 'true', { expires: 365, path: '/' });
    }
  });
}

$(function () {
  dark_mode_toggle();

  const autoCompleteJS = new autoComplete({
    selector: club_input,
    data: {
      src: async function (query) {
        try {
          const response = await $.ajax({
            url: competitions_api,
            type: 'POST',
            dataType: 'json',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': $.cookie('csrftoken'),
            },
            data: JSON.stringify({
              type: 'club_search',
              term: query,
            }),
          });
          return response.results;
        } catch (error) {
          console.error(error);
          return [];
        }
      },
      keys: ['name'],
    },
    resultsList: {
      maxResults: 10,
      noResults: true,
      tabSelect: true
    },
    threshold: 2,
    debounce: 300,
    searchEngine: function (query, record) {
      return record;
    },
  });

  autoCompleteJS.input.addEventListener('selection', function (event) {
    const feedback = event.detail;
    const club_id = feedback.selection.value['id'];
    const club_name = feedback.selection.value['name'];
    autoCompleteJS.input.blur();
    autoCompleteJS.input.value = club_name;
    $(club_input_wrapper).hide();
    $(club_input).val('');
    $(club_tag + ' span').html(club_name);
    $(club_tag).show();
    reload_upcoming_competitions(club_id);
  });

  if ($('#bracket-modal').length && competition_category_id) {
    competitions_api_request({
      type: 'bracket',
      competition_category: competition_category_id,
    });
    modal_open('bracket-modal');
  }

  PullToRefresh.init({
    mainElement: 'body',
    triggerElement: '.header',
    onRefresh() {
      window.location.reload();
    }
  });
});
